/* 도로명주소 api key */

// TODO 개인 API키로 나중에 회사키로 교체 필요
// 주소 검색
export const AddressSearchComfmKey = "U01TX0FVVEgyMDIxMDcyOTEwMTkyMTExMTQ2NjU=";
// 주소 -> 좌표
export const AddressToCoorComfmKey = "U01TX0FVVEgyMDIxMDcyOTE1MzE1MDExMTQ2ODI=";
